import { RANKS } from './cards.js';

const CATEGORY_NAMES = ['High Card', 'One Pair', 'Two Pair', 'Three of a Kind', 'Straight', 'Flush', 'Full House', 'Four of a Kind', 'Straight Flush'];

function descending(values) {
  return [...values].sort((a, b) => b - a);
}

export function evaluateHand(cards) {
  if (!Array.isArray(cards) || cards.length !== 5 || new Set(cards).size !== 5) throw new Error('A hand must contain five unique cards');
  const ranks = cards.map(card => RANKS.indexOf(card[0]) + 2);
  const suits = cards.map(card => card[1]);
  const counts = new Map();
  ranks.forEach(rank => counts.set(rank, (counts.get(rank) || 0) + 1));
  const groups = [...counts.entries()].sort((a, b) => b[1] - a[1] || b[0] - a[0]);
  const unique = descending(counts.keys());
  const isWheel = unique.join(',') === '14,5,4,3,2';
  const straightHigh = unique.length === 5 && (isWheel || unique[0] - unique[4] === 4) ? (isWheel ? 5 : unique[0]) : 0;
  const flush = suits.every(suit => suit === suits[0]);
  let category;
  let tiebreak;

  if (straightHigh && flush) [category, tiebreak] = [8, [straightHigh]];
  else if (groups[0][1] === 4) [category, tiebreak] = [7, [groups[0][0], groups[1][0]]];
  else if (groups[0][1] === 3 && groups[1][1] === 2) [category, tiebreak] = [6, [groups[0][0], groups[1][0]]];
  else if (flush) [category, tiebreak] = [5, descending(ranks)];
  else if (straightHigh) [category, tiebreak] = [4, [straightHigh]];
  else if (groups[0][1] === 3) [category, tiebreak] = [3, [groups[0][0], ...descending(groups.slice(1).map(group => group[0]))]];
  else if (groups[0][1] === 2 && groups[1][1] === 2) {
    const pairs = descending([groups[0][0], groups[1][0]]);
    [category, tiebreak] = [2, [...pairs, groups[2][0]]];
  } else if (groups[0][1] === 2) [category, tiebreak] = [1, [groups[0][0], ...descending(groups.slice(1).map(group => group[0]))]];
  else [category, tiebreak] = [0, descending(ranks)];

  return { category, name: CATEGORY_NAMES[category], tiebreak, score: [category, ...tiebreak] };
}

export function compareHands(a, b) {
  const left = a.score || evaluateHand(a).score;
  const right = b.score || evaluateHand(b).score;
  for (let i = 0; i < Math.max(left.length, right.length); i += 1) {
    if ((left[i] || 0) !== (right[i] || 0)) return (left[i] || 0) - (right[i] || 0);
  }
  return 0;
}

export function winners(hands) {
  const evaluated = hands.map(hand => ({ ...hand, evaluation: evaluateHand(hand.cards) }));
  const best = evaluated.reduce((top, current) => compareHands(current.evaluation, top.evaluation) > 0 ? current : top);
  return evaluated.filter(hand => compareHands(hand.evaluation, best.evaluation) === 0);
}
